import CommonAccordion from "./CommonAccordion";

export default CommonAccordion;
